<template>
  <transition name="modal-fade">
    <div class="info_modal" v-if="active">
      <div class="info_modal_inner tan" :style="modalStyle">
        <div class="row flush final_modal align_center">
          <div class="span_8_xs offset_2_xs">
            <p v-for="(paragraph, index) in text[ind]" class="modal_text" :key="index">{{paragraph}}</p>
            <button v-on:click="modalClose">Proceed</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: ['active', 'text', 'ind', 'modalStyle'],
    methods: {
      modalClose() {
        this.$emit('close')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// modal.vue?7dbdf60a